import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getVocWebsiteDataDefinitions } from "../../../api/vocApi";
import { RouteComponentProps, withRouter } from "react-router-dom";

interface DataUpdate {
  section: string;
  KPI: string;
  Definition: string;
  prompt: string;
}

const VocData = withRouter((props: RouteComponentProps) => {
  const { history } = props;
  const [dataUpdates, setDataUpdates] = useState<Array<DataUpdate>>();
  const [page, setPage] = useState<string>();

  useEffect(() => {
    const page = history.location.pathname.split("/").at(-1);
    setPage(page);
    getVocWebsiteDataDefinitions(page as string).then((response: any) => {
      if (response && "error" in response) {
        toast.error("Error fetching data updates");
      } else {
        setDataUpdates(response);
      }
    });
  }, [history]);

  return (
    <div className="data_documentation">
      <h3>{`${page} - DATA OVERVIEW` ?? "VOC - DATA OVERVIEW"}</h3>

      <br />

      <table className="docs_table">
        <thead>
          <tr>
            <th>Section</th>
            <th>KPI</th>
            <th>Definition</th>
          </tr>
        </thead>
        <tbody>
          {dataUpdates?.map((data, index) => (
            <tr key={index}>
              <td>{data.section}</td>
              <td>{data.KPI}</td>
              <td>{data.Definition}</td>
            </tr>
          ))}
        </tbody>

        <thead>
          <tr>
            <td colSpan={4} style={{ height: "32px", background: "transparent", border: "none" }} />
          </tr>
          <tr>
            <th>If filter selected is...</th>
            <th>Then...Score refers to...</th>
            <th>and Respondent Rate refers to...</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{"Last Month"}</td>
            <td>
              {`e.g. March 2025 -> March 2025`}
              <br />
              {`(March 2024)`}
            </td>
            <td>
              {`e.g. March 2025 -> March 2025`}
              <br />
              {`(March 2024)`}
            </td>
          </tr>

          <tr>
            <td>{"This Quarter"}</td>
            <td>
              {`e.g. May 2025 -> April-June 2025`}
              <br />
              {`average score (April-June 2024 `}
              <br />
              {`average monthly score)`}
            </td>
            <td>
              {`e.g. May 2025 -> April-June 2025`}
              <br />
              {`average score (April-June 2024`}
              <br />
              {`average monthly score)`}
            </td>
          </tr>

          <tr>
            <td>{"Last Quarter"}</td>
            <td>
              {`e.g. May 2025 -> April-June 2025`}
              <br />
              {`average score (April-June 2024`}
              <br />
              {`average monthly score)`}
            </td>
            <td>
              {`e.g. May 2025 -> April-June 2025`}
              <br />
              {`average score (April-June 2024`}
              <br />
              {`average monthly score)`}
            </td>
          </tr>

          <tr>
            <td>{"This financial year"}</td>
            <td>
              {`e.g. April 2025 -> YTD FY April 2025`}
              <br />
              {`average (YTD FY24 – April 2024)`}
              <br />
              {`average monthly score`}
            </td>
            <td>
              {`e.g. April 2025 -> YTD FY April 2025`}
              <br />
              {`average (YTD FY24 – April 2024)`}
              <br />
              {`average monthly score`}
            </td>
          </tr>

          <tr>
            <td>{"Last Financial year"}</td>
            <td>
              {`e.g. April 2024 -> YTD FY April 2024`}
              <br />
              {`average (YTD FY23 – April 2023)`}
              <br />
              {`average monthly score`}
            </td>
            <td>
              {`e.g. April 2024 -> YTD FY April 2024`}
              <br />
              {`average (YTD FY23 – April 2023)`}
              <br />
              {`average monthly score`}
            </td>
          </tr>

          <tr>
            <td>{"Start Month – End Month"}</td>
            <td>
              {`e.g. December 2024-April 2025 ->`}
              <br />
              {`Average monthly score from`}
              <br />
              {`Dec.2024-April 2025 (Average`}
              <br />
              {`monthly score from Dec.2023-April 2024)`}
            </td>
            <td>
              {`e.g. December 2024-April 2025 ->`}
              <br />
              {`Average monthly score from`}
              <br />
              {`Dec.2024-April 2025 (Average`}
              <br />
              {`monthly score from Dec.2023-April 2024)`}
            </td>
          </tr>
        </tbody>
      </table>
      <br />
      <br />
    </div>
  );
});

export default VocData;
